import { useTranslation } from 'react-i18next';

import { PaymentDeviceHeldRequest } from '@/models/in/PaymentDeviceDtoIn';
import { formatPickupDay } from '@/helpers/paymentDevices';

interface HeldRequestsListProps {
  requests: PaymentDeviceHeldRequest[];
  /** Opens the request, to hand its device over or cancel it. Without it the requests are plain text. */
  onOpen?: (requestId: number) => void;
}

/**
 * The approved requests that hold the free devices (HAT-1434). The list of devices says «פנוי» for
 * every one of them, since a request keeps «a device», not a given one; this says who holds them.
 */
const HeldRequestsList = ({ requests, onOpen }: HeldRequestsListProps) => {
  const { t } = useTranslation();

  return (
    <ul className="flex flex-col gap-1">
      {requests.map((request) => {
        const label = t('paymentDevices.held.request', {
          id: request.id,
          fund: `${request.fundId} | ${request.fundName ?? ''}`,
          date: formatPickupDay(request.holdUntil, false),
        });
        return (
          <li key={request.id} className="body-sm-regular">
            {onOpen ? (
              <button type="button" className="text-(--font-primary) underline text-start" onClick={() => onOpen(request.id)}>
                {label}
              </button>
            ) : label}
          </li>
        );
      })}
    </ul>
  );
};

export default HeldRequestsList;
